var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"search-bar__btn",attrs:{"type":"button","onclick":"window.location.href='/valuation'"}},[_vm._v(" GET STARTED "),_c('Icon',{attrs:{"icon":"chevron_right"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }